module.exports = __webpack_public_path__ + "img/ibk.7f0ed7a2.svg";